import React from 'react';
import styled from 'styled-components';
import { breakpoint, sizes } from 'variables';
import { toHtmlContent } from 'modules/helpers/strings';
import DefaultButton, { ButtonSize, ButtonStyle, IconPosition, withIcon } from 'modules/react-button';
import * as transKey from 'autogen/translation-keys/trans-root-website';
import { useTranslation } from 'react-i18next';
import { openSamplesModal } from 'components/samples/components/samplesPicker';
import type { MessageWithQueueCallbacks } from 'components/pages/Basket/components/BasketCheckoutActions/BasketCheckoutButton/BasketCheckoutMessagesButton';

const Wrapper = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    padding: 20px;

    ${breakpoint.up(sizes.sm)} {
        padding: 20px 40px;
    }
`;

const ButtonWrapper = styled.div`
    display: flex;
    flex-direction: column;
    width: 100%;

    ${breakpoint.up(sizes.sm)} {
        flex-direction: row;
        justify-content: space-between;
    }
`;

const Button = styled(DefaultButton)`
    margin-top: 30px;

    ${breakpoint.up(sizes.sm)} {
        flex: 1 1 auto;
    }

    & ~ & {
        ${breakpoint.up(sizes.sm)} {
            margin-left: 20px;
        }
    }
`;

const ButtonWithIcon = styled(withIcon(Button))``;

export default ({ message }: { message: MessageWithQueueCallbacks }): JSX.Element => {
    const { messageContent, closeAndCancelQueue, nextMessageInQueue, isLastMessage, loginLinkAction } = message;
    const { t } = useTranslation();
    const {
        Samples: { ChooseYourSample, SampleDecline },
        GoToCheckout
    } = transKey.Basket;

    async function onSamplesClickHandler(): Promise<void> {
        closeAndCancelQueue();
        openSamplesModal(t(ChooseYourSample), loginLinkAction.url);
    }

    return (
        <Wrapper>
            -{toHtmlContent(messageContent)}
            <ButtonWrapper>
                <Button
                    buttonSize={ButtonSize.lg}
                    buttonStyle={ButtonStyle.secondary}
                    data-js-modal-url={loginLinkAction.url}
                    onClick={onSamplesClickHandler}
                >
                    {t(ChooseYourSample)}
                </Button>
                <ButtonWithIcon
                    type="button"
                    buttonStyle={ButtonStyle.primary}
                    buttonSize={ButtonSize.lg}
                    onClick={nextMessageInQueue}
                    icon={{ iconType: 'ArrowRight', iconPosition: IconPosition.right }}
                >
                    {!isLastMessage ? t(SampleDecline) : t(GoToCheckout)}
                </ButtonWithIcon>
            </ButtonWrapper>
        </Wrapper>
    );
};
